import React, { createContext, useContext, useState } from 'react';

const GlobalContext = createContext(null);

function GlobalProvider({ children }) {
  const [dashboardTitle, setDashboardTitle] = useState('Dashboard');

  const value = {
    dashboardTitle,
    setDashboardTitle, 
  };

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  );
}

export default GlobalProvider;

export const useGlobal = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobal must be used inside GlobalProvider');
  }
  return context;
};
